import { Chip, useDisclosure } from "@heroui/react";
import { useState, useEffect } from "react";
import { Renter } from "@/api/renters";
import { RenterModal } from "./modals/renterModal";
import { useAppSelector } from "@/hooks/useAppSelector.ts";

export function FinanceRenterChip({
  renterId,
  callback,
}: {
  renterId: number;
  callback: (item: Renter) => void;
}) {
  const [item, setItem] = useState<Renter | null>(null);
  const items = useAppSelector((state) => state.handbooks.renter);

  useEffect(() => {
    if (renterId === -1) {
      setItem(null);
    } else {
      setItem(items.find((el) => el.id == renterId) || null);
    }
  }, [renterId, items]);

  return (
    <>
      {renterId === -1 && (
        <Chip variant="dot" color="danger">
          удалено
        </Chip>
      )}
      {renterId !== -1 && item !== null && (
        <Chip
          className="cursor-pointer min-h-fit"
          classNames={{ base: "whitespace-pre-line" }}
          onClick={() => callback(item)}
          variant="dot"
          color="primary">
          {item?.display_name}
        </Chip>
      )}
      {renterId !== -1 && item == null && (
        <Chip variant="dot" color="default">
          н/д
        </Chip>
      )}
    </>
  );
}

export function RenterChip({ renterId }: { renterId: number }) {
  const [item, setItem] = useState<Renter | null>(null);
  const disclosure = useDisclosure();
  const items = useAppSelector((state) => state.handbooks.renter);

  useEffect(() => {
    if (renterId === -1) {
      setItem(null);
    } else {
      setItem(items.find((el) => el.id == renterId) || null);
    }
  }, [renterId, items]);

  return (
    <>
      <RenterModal
        isOpen={disclosure.isOpen}
        onOpenChange={disclosure.onOpenChange}
        item={item!}
      />
      {renterId === -1 && (
        <Chip variant="dot" color="danger">
          удалено
        </Chip>
      )}
      {renterId !== -1 && item !== null && (
        <Chip
          className="cursor-pointer min-h-fit"
          classNames={{ base: "whitespace-pre-line" }}
          onClick={disclosure.onOpen}
          variant="dot"
          color="primary">
          {item?.display_name}
        </Chip>
      )}
      {renterId !== -1 && item == null && (
        <Chip variant="dot" color="default">
          н/д
        </Chip>
      )}
    </>
  );
}
